import React from 'react';
import { get, find } from 'lodash';

// local dependencies
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { AddInsuranceDiscountCardTodoService } from 'services/addInsuranceDiscountCardTodo';
import { addInsuranceDiscountCardTodo as AddInsuranceDiscountCardTodoView } from 'ui/views/widgets/addInsuranceDiscountCardTodo';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { AddInsuranceDiscountCardTodo } from 'ui/containers/AddInsuranceDiscountCardTodo';
 *
 * // render
 * <AddInsuranceDiscountCardTodo propName='propValue'/>
 */
export class AddInsuranceDiscountCardTodo extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.onFormSubmit = this.onFormSubmit.bind( this );

        this.addInsuranceDiscountCardTodoService = new AddInsuranceDiscountCardTodoService();
    }

    /**
     * Action executed when user submits form
     */
    async onFormSubmit ( formData ) {
        log.debug( 'AddInsuranceDiscountCardTodo.onFormSubmit()' );

        // get context and success action url
        const context = get( this.props, 'context', {} );
        const successAction = find( this.props.actions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        // get status of form submission
        const { status } = await this.addInsuranceDiscountCardTodoService.submitFormData( {
            url: successAction.url,
            data: {
                context,
                data: formData
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open(); // show error overlay
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AddInsuranceDiscountCardTodoView
                { ...this.props }
                onFormSubmit={ this.onFormSubmit }
            />
        );
    }
}

// set display name
AddInsuranceDiscountCardTodo.displayName = 'AddInsuranceDiscountCardTodo';

// set default props
AddInsuranceDiscountCardTodo.defaultProps = {};

// prop types
AddInsuranceDiscountCardTodo.propTypes = {};
